import qs from 'query-string';

export function searchOptsFromQueryParams(queryParams) {
  if (typeof queryParams === 'string') queryParams = qs.parse(queryParams);

  const hitsPerPage = 60;
  const skip = parseInt(queryParams.skip, 10) || 0;
  const page = skip ? Math.floor(skip / hitsPerPage) : 0;
  let opts = { hitsPerPage, page };

  const sortAttribute = queryParams.sort;
  const sortOrder = queryParams.order;
  if (sortAttribute) {
    opts.sort = { attribute: sortAttribute, desc: sortOrder === 'desc' };
  }

  delete queryParams.skip;
  delete queryParams.sort;
  delete queryParams.order;

  opts.filters = queryParams;

  return opts;
}

export function searchPageId(searchQuery, queryParams) {
  const { page, hitsPerPage, sort, filters } = searchOptsFromQueryParams(
    queryParams
  );

  return [
    searchQuery,
    page,
    hitsPerPage,
    sortId(sort),
    filtersId(filters)
  ].join('_');
}

function sortId(sort = {}) {
  let id = sort.attribute || '';
  if (sort.desc) id += ':desc';
  return id;
}

function filtersId(filters = {}) {
  return Object.keys(filters)
    .sort((a, b) => a > b)
    .map(key => `${key}:${filters[key]}`)
    .join('_');
}

export function countMayChange({
  prevSearchQuery,
  nextSearchQuery,
  prevSearchOpts = {},
  nextSearchOpts = {}
}) {
  if (nextSearchQuery !== prevSearchQuery) return true;
  const nextFilters = filtersId(nextSearchOpts.filters);
  const prevFilters = filtersId(prevSearchOpts.filters);
  return nextFilters !== prevFilters;
}
